import React from 'react';

export const ValidationError: React.FC<{ error?: string | string[] | null }> = ({ error }) => {
    if (!error) return null;
    const message = Array.isArray(error) ? error.join(', ') : error;
    return (
        <div
            role="alert"
            className="mt-2 flex items-start gap-2 rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700"
        >
            <span aria-hidden className="mt-0.5 shrink-0">
                💬
            </span>
            <span>{message}</span>
        </div>
    );
};
